import script from "./AlertCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertCard.vue?vue&type=script&setup=true&lang=ts"

import "./AlertCard.vue?vue&type=style&index=0&id=3e56c112&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e56c112"]])

export default __exports__